import React, { useState, useEffect, useRef} from "react";
import { useParams, useRouteMatch, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';


import { generateReportUrl, parseQueryParams } from 'services/report.service';

import { SessionAnalytics } from "./components/sessionAnalytics";
import { LeadAnalytics } from "./components/leadAnalytics"
import { GeographicAnalytics } from "./components/geographicAnalytics"
import { AssetAnalytics } from "./components/assetAnalytics";
import { InteractionAnalytics } from "./components/interactionAnalytics";
import { ReportSummary } from "./components/reportSummary";
import { MetricsAnalytics } from "./components/metricsAnalytics";
import { PageAnalytics } from "./components/pageAnalytics";
import { DatePickerView } from './components/datePicker';

import { fetchAllPagesForInteractiveStoryboard } from "actions/storyboard";
import { FOURTEEN_DAYS } from 'constants/report.jsx';
import { getReportDatesForOption } from 'services/report.service';
import { getPageViewedEventPayload } from "services/mixpanelUtil";
import { createMixpanelEvent } from "actions/mixpanel";
import { MIXPANEL_PAGE_VIEWED, MIXPANEL_PAGE_VIEWED_REPORTS } from "constants/mixpanelEvents";
import { JourneyAnalytics } from "./components/journeyAnalytics";
import cx from 'classnames';
import styles from './report.module.scss';

export default function ReportView(props) {
  const [reportDate, setReportDate] = useState({
    type: FOURTEEN_DAYS,
    ...getReportDatesForOption(FOURTEEN_DAYS)
  });
  let { url } = useRouteMatch();
  const ref = useRef(null);
  const { search } = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  let { storyboardId } = useParams();

  const storyboardName = useSelector(state => _.get(state, 'storyboards.storyboard.item.name', null));

  const handleDateChange = (value) => {
    setReportDate(value);
  }

  useEffect(() => {
    if (reportDate) {
      const updatedUrl = generateReportUrl(url, reportDate, search);
      history.replace(updatedUrl);
    }
  }, [reportDate]);

  useEffect(() => {
    const parsedDate = parseQueryParams(search);
    setReportDate(parsedDate);

    var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_REPORTS, storyboardId, storyboardName, "INTERACTIVE_CONTENT")
    dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload))

    dispatch(fetchAllPagesForInteractiveStoryboard({
      storyboard: storyboardId,
      draft: false
    }))
  }, []);

  return (
    <div className={styles.reportContainer} >
      <ReportSummary
        date={reportDate}
        storyboardType={"INTERACTIVE_CONTENT"}
      />

      <div className={cx(styles.reportFilters, styles.icDateFilter)}>
        <DatePickerView
          value={reportDate}
          onChange={handleDateChange}
        />
      </div>
      <div>
        <SessionAnalytics
          date={reportDate}
          storyboardType={"INTERACTIVE_CONTENT"}
        />
      </div>

      <div className={styles.reportsColumn}>
        <PageAnalytics
          date={reportDate}
          storyboardType={"INTERACTIVE_CONTENT"}
        />

        <InteractionAnalytics
          date={reportDate}
        />
      </div>

      <div>
        <AssetAnalytics
          date={reportDate}
        />
      </div>

      <div>
        <GeographicAnalytics
          date={reportDate}
          storyboardType={"INTERACTIVE_CONTENT"}
        />
      </div>

      <div className={styles.reportsColumn}>
        <MetricsAnalytics
          tableName="Device Analytics"
          metricType="device"
          paginationName="Devices"
          date={reportDate}
        />
        <MetricsAnalytics
          tableName="Account Analytics"
          metricType="organization"
          paginationName="Accounts"
          date={reportDate}
        />
      </div>

      <div>
        <LeadAnalytics
          showProfile={false}
          date={reportDate}
        />
      </div>

      <div ref={ref}>
          <JourneyAnalytics
            date={reportDate}
            storyboardType={"INTERACTIVE_CONTENT"}
          />
        </div>

      <div className={styles.reportsColumn}>
        <MetricsAnalytics
          tableName="UTM Source Analytics"
          metricType="utm_source"
          paginationName="UTM Sources"
          date={reportDate}
        />
        <MetricsAnalytics
          tableName="UTM Medium Analytics"
          metricType="utm_medium"
          paginationName="UTM Mediums"
          date={reportDate}
        />
      </div>
    </div>
  );
}